export default __webpack_public_path__ + "static/image-love-4d49b40f1bb3aa2b2c4d0994c4159142.png";